'use strict';

import SelectionGridFactory from './SelectionGrid';
import MultiSelectionTabService from './multiselection-tab.service';

export default angular
	.module('mx.sb.MultiSelectionTab', [])
	.factory('mx.SolutionBuilderAgent.SelectionGrid', SelectionGridFactory)
	.service('mx.SolutionBuilderAgent.MultiSelectionTabService', MultiSelectionTabService).name;
